import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { consume } from '@lit/context';
import { ltnToastServiceContext } from '../../../../ns-services/contexts.js';

import { LtnToastService } from '../../../../ltn-toast/ltn-toast-service.js';

import JobSchema from '../../../../models/job-schema.js';

import NSJobComponent from '../../job.js';

import '@awesome.me/webawesome/dist/components/input/input.js';
import '../../../../ns-elements/ns-job-layout.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import definition from '@job-schemas/company/join.json';
import { jobSchema } from '../../job-schema.js';

@customElement(NSCompanyJoin.is)
export default class NSCompanyJoin extends NSJobComponent {
  static get is() {
    return 'ns-company-join';
  }

  @consume({ context: ltnToastServiceContext })
  private __toast?: LtnToastService;

  private __companyTypes = [
    { value: 'PUBLIC_LIMITED_COMPANY', label: 'Public Limited Company' },
    { value: 'PRIVATE_LIMITED_COMPANY', label: 'Private Limited Company' },
    { value: 'PRIVATE_UNLIMITED_COMPANY', label: 'Private Unlimited Company' },
    { value: 'INTERNATIONAL_COMPANY', label: 'International Company' },
  ];

  static get schema(): JobSchema {
    return jobSchema(definition, {
      outcomes: { accept: { type: 'button', label: 'Accept' }, reject: { type: 'button', label: 'Reject' } },
    });
  }

  async connectedCallback() {
    await super.connectedCallback();

    if (!this._db) throw new Error('Unable to find db service');

    if (!this._directory) throw new Error('Unable to find NSWorkflowService');

    if (!this.__toast) throw new Error('Unable to find toast service');
  }

  render() {
    return html`
      <ns-job-layout>
        <div class="job-panel">
          <p>Search for or create a company using the field below.</p>
          <wa-input required id="company-search" type="text" placeholder="Company Name" label="Company name"></wa-input>
        </div>
      </ns-job-layout>
    `;
  }

  renderActions() {
    return html`
      <wa-button variant="brand" type="button">Create Company</wa-button>
      <wa-button variant="brand" appearance="outlined" type="button">Search</wa-button>
    `;
  }
}
